import { createSelector } from 'reselect'

import { selectPartnerSearchState } from './selectPartnerSearchState'

export const selectPartnerSearchFilters = createSelector(
  [selectPartnerSearchState],
  ({ filters }) => filters
)
